import { FormattedMessage } from 'react-intl';
import { Reference } from '../../../../types/basket';
import FormattedCurrency from '../../../atoms/FormattedCurrency';
import './style.scss';

const UnitPrice = ({ costWithTax, dimension }: Reference) => (
  <div className="unit-price">
    <FormattedMessage
      id="basket.item.unitPrice"
      values={{
        price: <FormattedCurrency value={costWithTax} />,
        unit: dimension
      }}
    />
  </div>
);

export default UnitPrice;
